/**
 * Variant stage type identifiers (single source of truth).
 *
 * Values match the backend `stage_type` field 1:1 and double as URL route
 * segments and `useVariantStep()` lookup keys.
 * Quelle: https://reactrouter.com/6.28.0/hooks/use-params
 *
 * Adding a new stage: add the constant here and the route in Startup.tsx.
 */

export const VARIANT_STAGE_TYPES = {
  CLINICAL_OBSERVATION: 'clinical_observation',
  FREQUENCY_DATA: 'frequency_data',
  MOLECULAR_IMPACT: 'molecular_impact',
  INTERPRETATION: 'interpretation',
} as const;

export type VariantStageType =
  (typeof VARIANT_STAGE_TYPES)[keyof typeof VARIANT_STAGE_TYPES];
